import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "small mb-1" };
const _hoisted_2 = { class: "d-none d-lg-inline ms-1" };
const _hoisted_3 = {
    key: 0,
    class: "fw-bold d-flex flex-column flex-md-row"
};
const _hoisted_4 = { key: 0 };
const _hoisted_5 = {
    key: 1,
    class: "fw-bold d-flex flex-column flex-md-row"
};
const _hoisted_6 = {
    key: 2,
    class: "fw-bold d-flex flex-column flex-md-row"
};
const _hoisted_7 = {
    class: "modal-title text-center w-100 mb-4",
    style: { "color": "#A4C610" }
};
const _hoisted_8 = { class: "px-3 px-md-5 pt-1 pb-0 text-center" };
const _hoisted_9 = { class: "row justify-content-center" };
const _hoisted_10 = {
    key: 0,
    class: "col-12 col-lg-6 p-3"
};
const _hoisted_11 = {
    class: "border p-3",
    style: { "border-radius": "10px" }
};
const _hoisted_12 = { class: "mb-3" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_15 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_18 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_19 = { class: "row" };
const _hoisted_20 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_21 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_22 = { class: "row" };
const _hoisted_23 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_24 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_25 = {
    key: 1,
    class: "col-12 col-lg-6 p-3"
};
const _hoisted_26 = {
    class: "border p-3",
    style: { "border-radius": "10px" }
};
const _hoisted_27 = { class: "mb-3" };
const _hoisted_28 = { class: "row" };
const _hoisted_29 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_30 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_31 = { class: "row" };
const _hoisted_32 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_33 = { class: "row" };
const _hoisted_34 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_35 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_36 = { class: "row" };
const _hoisted_37 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_38 = ["innerHTML"];
const _hoisted_39 = {
    key: 2,
    class: "col-12 col-lg-6 p-3"
};
const _hoisted_40 = {
    class: "border p-3",
    style: { "border-radius": "10px" }
};
const _hoisted_41 = { class: "mb-3" };
const _hoisted_42 = { class: "row" };
const _hoisted_43 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_44 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_45 = { class: "row" };
const _hoisted_46 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_47 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_48 = { class: "row" };
const _hoisted_49 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_50 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_51 = { class: "row" };
const _hoisted_52 = { class: "col-12 col-xl-6 text-start fw-bold" };
const _hoisted_53 = { class: "col-12 col-xl-6 text-start" };
const _hoisted_54 = { class: "row" };
const _hoisted_55 = { class: "col-12" };
const _hoisted_56 = ["innerHTML"];
const _hoisted_57 = { class: "row mt-4 mb-5" };
const _hoisted_58 = { class: "row col-12 col-lg-6" };
const _hoisted_59 = { class: "d-flex justify-content-center mb-3 mb-lg-0" };
const _hoisted_60 = { class: "ms-3 text-start" };
const _hoisted_61 = ["href"];
const _hoisted_62 = { class: "row col-12 col-lg-6" };
const _hoisted_63 = { class: "d-flex justify-content-center" };
const _hoisted_64 = { class: "ms-3 text-start" };
const _hoisted_65 = ["href"];
import axios from 'axios';
import Swal from 'sweetalert2';
import { onMounted, ref, watch } from 'vue';
import { loadTenantConfigs } from '../Composables/standardFunctions';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ColorManager',
    props: {
        maxColors: {
            type: Number,
            default: 4
        },
        allowedPrintModes: {
            type: Array,
            default: [1, 2, 3] //1=silkscreen, 2=digital, 3=gravure
        },
        textColors: {
            type: Array,
            default: []
        },
        imageColors: {
            type: Array,
            default: []
        },
        imagesAmount: {
            type: Number,
            default: 0
        },
        requiresDigitalPrintMode: {
            type: Boolean,
            default: false
        },
        shouldBlockFurtherConfiguration: {
            type: Boolean,
            default: true
        },
        configurationType: {
            type: String,
            default: null
        },
        printConfigurationUuid: {
            type: String,
            default: null
        },
        preSelectedPrintType: {
            type: Number,
            default: null
        }
    },
    emits: ['blockFurtherConfiguration', 'canSelectEngravingPrintMode'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const emit = __emit;
        const colorsAmount = ref(0);
        const printType = ref(null);
        const blockConfiguration = ref(false); //TODO: Do not allow further configuration until change to false! Colors must be reduced to maxColors!
        const blockConfigurationMessage = ref(null);
        const standardProductType = ref(null);
        const printingMethodsName = ref('Druckverfahren');
        const contactEmail = ref('');
        const contactPhone = ref('');
        const modal = ref();
        onMounted(async () => {
            definePrintType();
            contactEmail.value = await loadTenantConfigs('mail_contact');
            contactPhone.value = await loadTenantConfigs('phone');
            standardProductType.value = await loadTenantConfigs('standard_product_type');
            if (standardProductType.value == 'glass') {
                printingMethodsName.value = 'Dekorationsverfahren';
            }
        });
        function definePrintType() {
            let lastPrintType = printType.value;
            const distinctColors = [...new Set([...props.textColors, ...props.imageColors])];
            colorsAmount.value = distinctColors.length;
            blockConfiguration.value = false;
            if (props.allowedPrintModes.includes(2) && props.allowedPrintModes.length == 1) {
                printType.value = 2;
            }
            if (props.requiresDigitalPrintMode) {
                printType.value = 2;
                if (!props.allowedPrintModes.includes(2)) {
                    if (props.allowedPrintModes.includes(1) || props.allowedPrintModes.includes(3)) {
                        blockConfiguration.value = true;
                        if (props.allowedPrintModes.length == 1) {
                            if (props.allowedPrintModes.includes(1)) {
                                printType.value = 1;
                                blockConfigurationMessage.value = t('Für dieses Design ist nur ein Siebdruck möglich. Bitte entfernen Sie die letzte Grafik oder reduzieren Sie die Farben, um fortfahren zu können.');
                            }
                            if (props.allowedPrintModes.includes(3)) {
                                printType.value = 3;
                                blockConfigurationMessage.value = t('Für dieses Design ist nur eine Gravur möglich. Bitte entfernen Sie die letzte Grafik oder reduzieren Sie die Farben, um fortfahren zu können.');
                            }
                        }
                        else if (props.allowedPrintModes.includes(1) && props.allowedPrintModes.includes(3)) {
                            printType.value = 1;
                            if (props.preSelectedPrintType != null && props.allowedPrintModes.includes(props.preSelectedPrintType)) {
                                printType.value = props.preSelectedPrintType;
                            }
                            blockConfigurationMessage.value = t('Für dieses Design ist nur Siebdruck oder Gravur möglich. Bitte entfernen Sie die letzte Grafik oder reduzieren Sie die Farben, um fortfahren zu können.');
                        }
                    }
                }
            }
            else {
                if (colorsAmount.value > props.maxColors) {
                    if (props.allowedPrintModes.includes(2)) {
                        printType.value = 2;
                    }
                    else if (props.allowedPrintModes.includes(1) || props.allowedPrintModes.includes(3)) {
                        blockConfiguration.value = true;
                        if (props.allowedPrintModes.length == 1) {
                            if (props.allowedPrintModes.includes(1)) {
                                printType.value = 1;
                                blockConfigurationMessage.value = t('Für dieses Design ist nur ein Siebdruck möglich. Bitte entfernen Sie die letzte Grafik oder reduzieren Sie die Farben, um fortfahren zu können.');
                            }
                            if (props.allowedPrintModes.includes(3)) {
                                printType.value = 3;
                                blockConfigurationMessage.value = t('Für dieses Design ist nur eine Gravur möglich. Bitte entfernen Sie die letzte Grafik oder reduzieren Sie die Farben, um fortfahren zu können.');
                            }
                        }
                        else if (props.allowedPrintModes.includes(1) && props.allowedPrintModes.includes(3)) {
                            printType.value = 1;
                            if (props.preSelectedPrintType != null && props.allowedPrintModes.includes(props.preSelectedPrintType)) {
                                printType.value = props.preSelectedPrintType;
                            }
                            blockConfigurationMessage.value = t('Für dieses Design ist nur Siebdruck oder Gravur möglich. Bitte entfernen Sie die letzte Grafik oder reduzieren Sie die Farben, um fortfahren zu können.');
                        }
                    }
                }
                if (props.allowedPrintModes.includes(3) && !props.allowedPrintModes.includes(1)) {
                    if (colorsAmount.value <= 1) {
                        printType.value = 3;
                    }
                    else {
                        blockConfiguration.value = true;
                        blockConfigurationMessage.value = t('Für dieses Design ist nur eine Gravur möglich. Bitte entfernen Sie die letzte Grafik oder reduzieren Sie die Farben, um fortfahren zu können.');
                    }
                }
                if (colorsAmount.value <= props.maxColors && props.allowedPrintModes.includes(1)) {
                    printType.value = 1;
                }
                if (colorsAmount.value <= 1 && props.allowedPrintModes.includes(1) && props.allowedPrintModes.includes(3)) {
                    printType.value = 1;
                    if (props.preSelectedPrintType == 3) {
                        printType.value = props.preSelectedPrintType;
                    }
                }
            }
            if (lastPrintType != printType.value && printType.value == 2 && props.imagesAmount > 0) {
                const startTimestamp = sessionStorage.getItem('startConfigurationTimestamp');
                //if configuration start is less than 10 seconds ago, show the info
                if (!(startTimestamp && (Date.now() - parseInt(startTimestamp, 10)) <= 10000)) {
                    showDigitalPrintModeChangeInfo();
                }
            }
            updatePrintConfigurationPrintMode();
            if (props.shouldBlockFurtherConfiguration) {
                emit('blockFurtherConfiguration', blockConfiguration.value, blockConfigurationMessage.value);
            }
        }
        watch(() => [props.textColors, props.imageColors, props.preSelectedPrintType], () => {
            definePrintType();
        }, { deep: true });
        function updatePrintConfigurationPrintMode() {
            if (props.configurationType == null || props.printConfigurationUuid == null) {
                return;
            }
            if (printType.value != 2 && colorsAmount.value <= 1) {
                emit('canSelectEngravingPrintMode', true);
            }
            else {
                emit('canSelectEngravingPrintMode', false);
            }
            axios.put(route('configurator.printConfiguration.printMode.update', props.printConfigurationUuid), {
                configurationType: props.configurationType,
                printModeId: printType.value
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function showDigitalPrintModeChangeInfo() {
            Swal.fire({
                title: t('Wechsel in den Digitaldruck'),
                html: trans('Die hochgeladene Grafik enthält mehr als {maxColors} Farben oder die Farben konnten nicht automatisch ermittelt werden.<br />Das ist zum Beispiel bei Bilddateien wie JPG oder PNG der Fall.<br /><br />In diesem Fall ist nur ein Digitaldruck möglich.', { maxColors: props.maxColors }),
                icon: 'info',
                confirmButtonText: t("Weitermachen"),
                confirmButtonColor: "#528399",
                footer: '<a href="#" data-bs-toggle="modal" data-bs-target="#printModes">' + t("Weitere Informationen zu unseren " + printingMethodsName.value) + '</a>'
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    class: "btn btn-light d-flex align-items-center flex-column position-absolute end-0 top-0 rounded p-3",
                    style: { "z-index": "999" },
                    onClick: _cache[0] || (_cache[0] = ($event) => (modal.value.open($event)))
                }, [
                    _createElementVNode("span", _hoisted_1, [
                        _createTextVNode(_toDisplayString(_unref(t)(printingMethodsName.value)), 1),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('für Ihr Design')), 1)
                    ]),
                    (printType.value == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                            _createTextVNode(_toDisplayString(_unref(t)('Siebdruck')), 1),
                            (colorsAmount.value)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "d-none d-md-inline ms-1" }, " | ", -1)),
                                    _createTextVNode(_toDisplayString(colorsAmount.value) + " " + _toDisplayString(_unref(t)('Farbe(n)')), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    (printType.value == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            _createTextVNode(_toDisplayString(_unref(t)('Digitaldruck')), 1),
                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "d-none d-md-inline ms-1" }, " | ", -1)),
                            _createTextVNode(_toDisplayString(_unref(t)('Beliebige Farb-Anzahl')), 1)
                        ]))
                        : _createCommentVNode("", true),
                    (printType.value == 3)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('Gravur')), 1))
                        : _createCommentVNode("", true)
                ]),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal,
                    id: "printModes",
                    size: 'lg'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(t)('Unsere ' + printingMethodsName.value)), 1),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                (props.allowedPrintModes.includes(1))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(t)('Siebdruck')), 1),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('Farbanzahl')), 1),
                                                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(t)('Maximal')) + " " + _toDisplayString(props.maxColors), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('Dateiformate')), 1),
                                                _createElementVNode("div", _hoisted_18, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Vektorgrafiken')), 1),
                                                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                                    _cache[4] || (_cache[4] = _createTextVNode("(EPS,SVG, AI, PDF) ", -1))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_19, [
                                                _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(t)('Spülmaschineneignung')), 1),
                                                _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('Für Reinigung mit Spülmaschinen geeignet')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('Druckbilder')), 1),
                                                _createElementVNode("div", _hoisted_24, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Texte und Logos')), 1),
                                                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                                    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1))
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (props.allowedPrintModes.includes(2))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("h3", _hoisted_27, _toDisplayString(_unref(t)('Digitaldruck')), 1),
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('Farbanzahl')), 1),
                                                _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)('unlimitierte Farbanzahl')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_31, [
                                                _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('Dateiformate')), 1),
                                                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-12 col-xl-6 text-start" }, [
                                                    _createTextVNode("JPG, PNG, PDF"),
                                                    _createElementVNode("br"),
                                                    _createElementVNode("br")
                                                ], -1))
                                            ]),
                                            _createElementVNode("div", _hoisted_33, [
                                                _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)('Spülmaschineneignung')), 1),
                                                _createElementVNode("div", _hoisted_35, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Handspülen empfohlen')), 1),
                                                    _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                                                    _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_36, [
                                                _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)('Druckbilder')), 1),
                                                _createElementVNode("div", {
                                                    class: "col-12 col-xl-6 text-start",
                                                    innerHTML: _unref(t)('Fotos,<br />komplexe Farbverläufe,<br />Personalisierung')
                                                }, null, 8, _hoisted_38)
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true),
                                (props.allowedPrintModes.includes(3))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                            _createElementVNode("h3", _hoisted_41, _toDisplayString(_unref(t)('Gravur')), 1),
                                            _createElementVNode("div", _hoisted_42, [
                                                _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(t)('Farbanzahl')), 1),
                                                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('Maximal')) + " 1", 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_45, [
                                                _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('Dateiformate')), 1),
                                                _createElementVNode("div", _hoisted_47, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Vektorgrafiken')), 1),
                                                    _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                                    _cache[12] || (_cache[12] = _createTextVNode("(EPS,SVG, AI, PDF) ", -1))
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_48, [
                                                _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(t)('Spülmaschineneignung')), 1),
                                                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(t)('Für Reinigung mit Spülmaschinen geeignet')), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_51, [
                                                _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(t)('Druckbilder')), 1),
                                                _createElementVNode("div", _hoisted_53, [
                                                    _createTextVNode(_toDisplayString(_unref(t)('Texte und Logos')), 1),
                                                    _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
                                                    _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                                                    _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1))
                                                ])
                                            ])
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("p", {
                                        class: "fw-bold",
                                        innerHTML: _unref(t)('Haben Sie noch Fragen zu unseren ' + printingMethodsName.value + ' oder benötigen Sie Hilfe bei der<br />Erstellung Ihrer Druckdaten? Wir unterstützen Sie gerne!')
                                    }, null, 8, _hoisted_56)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("div", _hoisted_59, [
                                        _cache[17] || (_cache[17] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "50",
                                            fill: "currentColor",
                                            class: "bi bi-envelope",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" })
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("strong", null, _toDisplayString(_unref(t)('E-Mail')), 1),
                                            _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
                                            _createElementVNode("a", {
                                                href: 'mailto:' + contactEmail.value
                                            }, _toDisplayString(contactEmail.value), 9, _hoisted_61)
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                        _cache[19] || (_cache[19] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            height: "50",
                                            fill: "currentColor",
                                            class: "bi bi-telephone",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" })
                                        ], -1)),
                                        _createElementVNode("div", _hoisted_64, [
                                            _createElementVNode("strong", null, _toDisplayString(_unref(t)('Telefon')), 1),
                                            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                            _createElementVNode("a", {
                                                href: 'tel:' + contactPhone.value
                                            }, _toDisplayString(contactPhone.value), 9, _hoisted_65)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
